import {PropertyState} from './PropertyState';
import {isString} from '../../../types/guards/isString';

export function isPropertyState(o?: any): o is PropertyState {
    return isString(o?.id)
        && isString(o?.overrideValue)
        && isString(o?.allowUserOverride);
}
